import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Injectable,
  Input,
  Output,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { TemplateService } from '../../../../../common/services/Template.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { Select2OptionData, Select2TemplateFunction } from 'ng2-select2';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from '../../../../../common/services/Search.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { TicketTypeService } from '../../../../../common/services/TicketType.service';
import { FieldService } from '../../../../../common/services/Field.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { Router } from '@angular/router';
import { CommentService } from '../../../../../common/services/Comment.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import * as _ from 'lodash';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { IvrgatewayService } from '../../../../../common/services/Ivrgateway.service';
import { environment } from 'environments/environment';
import { MailboxService } from 'app/common/services/Mailbox.service';
import { UtilityService } from 'app/common/services/Utility.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ChanelAudioContent } from './detail_ticket.const';
import { AIGatwayService } from '../../../../../common/services/AIGatway.service';
import { UserSharedService } from '../../customer/UserSharedService';
import { Observable } from 'rxjs';
import {
  ExpertField,
  FieldType,
  TemplateType,
  UserField,
  TicketField,
} from '../../setting/other/template/template.const';
import { EmailService } from '../../../../../common/services/Email.service';
import { SocialService } from '../../../../../common/services/Social.service';
import { CustomerType, Gender, RoleForAgent } from '../user/detail_user.const';
import { FormFieldType, ModalType } from '../../../../../components/modals/modal-form-template/modal-form.const';
import * as Mustache from 'mustache';
import { showPhoneNumberInString } from '../../../../../common/utils/common';
import { BaseComponent } from '../../../../../components/base.component';
import { CoreTemplateService } from '../../../../../common/services/CoreTemplate.service';
import { MergeModalType } from '../../../../../components/modals/merge-modal/merge-modal.const';

declare var $: any;
declare const Timer: any;

@Component({
  moduleId: module.id,
  selector: 'detail-ticket',
  templateUrl: './detail_ticket.component.html',
  styleUrls: ['../detail.css', './ticket.css'],
  providers: [
    TicketService,
    TemplateService,
    GroupService,
    UserService,
    AIGatwayService,
    BsModalService,
    SearchService,
    ServiceService,
    PriorityService,
    TicketTypeService,
    FieldService,
    UploadService,
    CommonService,
    CommentService,
    IvrgatewayService,
    MailboxService,
    EmailService,
    SocialService,
    CoreTemplateService,
  ],
})
@Injectable()
export class DetailTicketComponent extends BaseComponent {
  public upload_url = environment.api_evs;
  public option_group: any = {};
  public option_agent: any = {};

  public modelGroup: any = {};
  public modelAgent: any = {};
  public no_image: any = 'assets/images/contact.png';
  public modelComment: any = { is_publish: false, attachments: [] };
  minDate = new Date();

  @Input() ticket;
  @Input() tabIndex;
  @Input() action;
  @Output('comeback') comeback = new EventEmitter();

  public model: any = { tags: [] };
  public modalMergeType = MergeModalType.Ticket;

  @ViewChild('templateGroup') templateGroup: ElementRef;
  @ViewChild('templateUser') templateUser: ElementRef;
  @ViewChild('templateMergeTicket') templateMergeTicket: ElementRef;
  @ViewChild('templateMail') templateMail: ElementRef;
  @ViewChild('templateZNS') templateZNS: ElementRef;
  @ViewChild('templateSMS') templateSMS: ElementRef;
  @ViewChild('templateAudioContent') templateAudioContent: ElementRef;
  public submit_status: any = '1';
  public current_status: any = '1';

  public submit_status_label: any = 'Mới';
  public allStatus: any = [{ id: '', text: '' }];
  public allTemplate: any = [{ id: '', text: '' }];
  public allGroup: any = [{ id: '', text: '' }];
  public allUserGroup: any = [];
  public allAgent: any = [];
  public agentInGroup: any = [{ id: '', text: '' }];
  public allService: any = [
    {
      field: 'service_id',
      list: [{ id: '', text: '' }],
    },
  ];
  public allType: any = [{ id: '', text: '' }];
  public allPriority: any = [{ id: '', text: '' }];
  public allFillterGroup: any = [{ id: '', text: '' }];
  public templates: any = [];

  public change_requester = true; // yeu cau thay doi nguwoiwf yeu cau

  public showAutoComplete = false;
  public userList: any = []; // danh sach user search
  public is_searching = false;
  public for_what: any; // nhan biet la cho truong nao nguwoiwf yeu cầu, hay chuyên viên
  public fields: any = []; // danh sách field mở rộng
  public userFields: any = []; // danh sách field mở rộng
  public close_tab = true; // đóng cửa sổ hay không khi submit
  public change_subject: any = false;
  public comments: any = [];
  public audio_contents: any = [];
  public emailAccounts: any = [];
  public repByEmail = false;
  public is_mute = false;
  public is_hold = false;
  public is_forward = false;
  public is_invite = false;
  public is_to_ACD = false;
  public is_to_IVR = false;
  public is_out_phone = false;
  public is_answered = false;
  public modelPhoneOut: any = {};
  public modelFilter: any = {};
  public modelMail: any = {};
  public modelZns: any = {};
  public modelSms: any = {};
  public modelFillterConnector: any = {};
  public connector_type: string;
  public is_load_data = false;
  public can_assign_agent_id = false;
  // pagiagion
  public list: any = [];
  public totalItem: any = 0;
  public totalPage: any = 0;
  public page_size = 5;
  public currentPage = 1;
  public modelMerge: any = {};
  public listMergeTicket: any = {};
  public totalItemMergeTicket: any = 0;
  public totalPageMergeTicket: any = 0;
  public currentPageMergeTicket = 1;
  public optionMerge: any = {};
  public page_size1 = 5;
  public cdns: any = [];
  public contentKeyArray: any = [];
  public allOaZalo: any = [];
  public lstTemplateEmail: any = [];
  public allTemplateEmail: any = [];
  public lstTemplateZns: any = [];
  public allTemplateZns: any = [];
  public lstTemplateSms: any = [];
  public allTemplateSms: any = [];
  public lstAgents: any = [];
  public phoneArray: any = [];
  public displaySubject: string = '';

  protected readonly ChanelAudioContent = ChanelAudioContent;
  protected readonly showPhoneNumberInString = showPhoneNumberInString;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private router: Router,
    private ticketService: TicketService,
    private templateService: TemplateService,
    private groupService: GroupService,
    private userService: UserService,
    private aiGatwayService: AIGatwayService,
    private searchService: SearchService,
    private fieldService: FieldService,
    private uploadService: UploadService,
    private commonService: CommonService,
    private commentService: CommentService,
    private socketService: SocketService,
    private IvrgatewayService: IvrgatewayService,
    private mailboxService: MailboxService,
    private domSanitizer: DomSanitizer,
    private sharedService: UserSharedService,
    private emailService: EmailService,
    private socialService: SocialService,
    private coreTemplateService: CoreTemplateService
  ) {
    super(changeDetector, toastr, modalService);
    this.listen();
  }

  public get publishChat() {
    if (this.modelComment.is_publish) {
      return 'publish';
    }
    return 'private';
  }

  public set publishChat(value: string) {
    if (value === 'publish') {
      this.modelComment.is_publish = true;
    }
    if (value === 'private') {
      this.modelComment.is_publish = false;
    }
  }

  ngOnInit() {
    this.is_load_data = true;
    this.option_group = {
      placeholder: { id: '', text: 'Bộ phận' },
      templateResult: this.templateResult,
      templateSelection: this.templateSelection,
    };
    this.option_agent = {
      placeholder: { id: '', text: 'Chuyên viên' },
      templateResult: this.templateResult,
      templateSelection: this.templateSelection,
    };
    $('.choice-template').select2({
      placeholder: '--Sử dụng mẫu trả lời nhanh--',
    });

    Observable.forkJoin([
      this.getGroup(),
      this.getAllAgent(),
      this.getTemplate(),
      this.commonService.settingCommon(),
      this.getMyFields(),
      this.getUserFields(),
      this.loadEmailAccount(),
    ]).subscribe(data => {
      this.getPriorities(data[3].data.allPriority);
      this.getTypes(data[3].data.allType);
      this.getServices(data[3].data.allService);
      this.getStatus(data[3].data.status);
      this.loadTemplate('sms');
      this.loadTemplate('email');
      this.loadTemplate('zns');
      this.getData();
      this.loadZaloOa();
    });

    this.change_requester = this.action == 'new';
    // load cdns
    const temps = environment.wav_cdn.split('|');
    temps.forEach(temp => {
      if (temp != null && temp.indexOf('-') != -1) {
        temp = temp.trim();
        const items = temp.split('-');
        this.cdns.push({ ip: items[0], url: items[1] });
      }
    });
    // set da lang nghe roi
    document.getElementById('ticketCallId').innerHTML = this.ticket.call_id;
  }

  changedSubject($event: any) {
    this.model.subject = $event;
    this.displaySubject = showPhoneNumberInString($event, this.user);
  }

  isArrays(obj: any) {
    return Array.isArray(obj);
  }

  isString(obj: any) {
    return typeof obj === 'string';
  }

  listen() {
    const timer = new Timer();
    this.socketService.missionAnnounced$.subscribe(mission => {
      if (mission.action == 'endCall') {
        this.is_answered = false;
        this.endCall(mission, timer);
      }
      if (mission.action == 'answer') {
        this.is_answered = true;
        this.answer(mission, timer);
      }

      if (mission.action == 'hold') {
        this.is_hold = true;
        this.is_mute = true;
      }

      if (mission.action == 'unHold') {
        this.is_hold = false;
        this.is_mute = false;
      }

      if (mission.action == 'mute') {
        this.is_mute = true;
      }

      if (mission.action == 'unMute') {
        this.is_mute = false;
      }

      if (mission.action == 'available-agent') {
        this.list = mission.data.agents;
      }
      if (mission.action == 'ring') {
        this.is_answered = false;
        if (this.ticket._id == mission.data.ticketId) {
          this.action = 'ring';
          this.ticket.call_id = mission.data.callId;
          document.getElementById('ticketCallId').innerHTML = this.ticket.call_id;
        } else if (this.ticket.call_id == mission.data.callId) {
          document.getElementById('ticketCallId').innerHTML = this.ticket.call_id;
          this.action = 'ring';
        }
        this.ticket.receiver_id = null;
        // gan tam o client truoc khi answer
        if (!this.ticket.assign_agent_id) {
          this.model['assign_group_id'] = this.user.group_id;

          this.model['assign_agent_id'] = this.user._id;
        } else {
          this.model['assign_group_id'] = this.ticket.assign_group_id;

          this.model['assign_agent_id'] = this.ticket.assign_agent_id;
        }
      }
    });
  }

  answer(mission, timer) {
    timer.reset();
    if (this.ticket.call_id == mission.data.callId) {
      const requester = this.ticket.request.name
        ? this.ticket.request.name
        : this.ticket.request.phone
          ? this.ticket.request.phone
          : this.ticket.request.email;
      let subject = this.ticket.subject;
      if (mission.data.callId.endsWith('CTC')) {
        this.ticket.source_detail = 'CALL_OUTBOUND';
      }
      if (this.ticket.source_detail == 'CALL_INBOUND') {
        subject = 'Cuộc gọi từ ' + requester;
      } else {
        subject = 'Cuộc gọi tới ' + requester;
      }
      const data = {
        subject: subject,
        receiver_id: this.user._id,
        time_start: moment(),
      };
      if (!this.ticket.assign_agent_id) {
        data['assign_group_id'] = this.user.group_id;

        data['assign_agent_id'] = this.user._id;
      } else {
        data['assign_group_id'] = this.ticket.assign_group_id;

        data['assign_agent_id'] = this.ticket.assign_agent_id;
      }
      setTimeout(() => {
        this.model['assign_group_id'] = data['assign_group_id'];

        this.model['assign_agent_id'] = data['assign_agent_id'];
      }, 3000);

      this.ticketService.update(this.ticket._id, data).subscribe(res => {
        this.ticket.receiver_id = this.user._id;
        this.ticket.time_start = moment();

        const dataShare = res.data;
        dataShare.subject = this.model.subject;
        dataShare.assign_agent_id = this.model.assign_agent_id;
        dataShare.status = this.model.status;
        dataShare.updated_at = new Date();
        this.sharedService.onTicketUpdate.emit(dataShare);
      });
    }
    this.is_hold = false;
    this.is_mute = false;
    timer.start();
    timer.addEventListener('secondsUpdated', function (e) {
      $('#call_time').html(timer.getTimeValues().toString());
    });
  }

  changeAssigner() {
    if (this.is_load_data) {
      setTimeout(() => {
        this.changeAssigner();
      }, 100);
    } else {
      this.changedAssignGroup({ value: this.user.group_id });
      this.changedAssignUser({ value: this.user._id });
    }
  }

  endCall(mission, timer) {
    timer.stop();
    this.is_forward = false;
    this.is_invite = false;
    this.is_to_ACD = false;
    this.is_to_IVR = false;
    this.is_out_phone = false;
    if (this.ticket.call_id == mission.data.callId) {
      // xác định tab đang gọi điện
      const _time_end = moment();
      const _finisher = mission.data.finisher || 'agent';
      const payload = {
        time_end: _time_end,
        finisher: _finisher,
        assign_agent_id: this.user._id,
      };

      const requester = this.ticket.request.name
        ? this.ticket.request.name
        : this.ticket.request.phone
          ? this.ticket.request.phone
          : this.ticket.request.email;
      if (!this.ticket.receiver_id) {
        this.model.subject = payload['subject'] = 'Cuộc gọi nhỡ với ' + requester;
      } else {
        if (this.ticket.source_detail == 'CALL_INBOUND') {
          this.model.subject = payload['subject'] = 'Cuộc gọi từ ' + requester;
        } else {
          this.model.subject = payload['subject'] = 'Cuộc gọi tới ' + requester;
        }
      }
      this.ticketService
        .update(this.ticket._id, payload)
        .toPromise()
        .then(res => {
          this.action = 'edit';
          if (this.ticket.time_start) {
            this.ticket.time_discuss = moment
              .utc(moment(_time_end, 'YYYY-MM-DD HH:mm:ss').diff(moment(this.ticket.time_start, 'YYYY-MM-DD HH:mm:ss')))
              .format('HH:mm:ss');
          }
          if (!this.model.requester_id) {
            this.model.requester_id = res.data.requester_id;
          }
          this.comeback.emit({
            ticket: this.ticket,
          });
          this.socketService.editTab(this.tabIndex, 'edit');
          this.model.assign_agent_id = res.data.assign_agent_id;
          const dataShare = res.data;
          dataShare.subject = this.model.subject;
          dataShare.assign_agent_id = this.model.assign_agent_id;
          dataShare.status = this.model.status;
          dataShare.updated_at = new Date();
          this.sharedService.onTicketUpdate.emit(dataShare);
          this.getComment(this.ticket._id);
          if (this.model.assign_agent_id) {
            const agent = this.allAgent.find(e => e.id == this.model.assign_agent_id);
            this.model.assign_group_id = agent ? agent.group_id : '';
            this.is_load_data = false;
            this.changedAssignGroup({ value: this.model.assign_group_id });
          }
        });
    }
  }

  getData() {
    this.is_load_data = true;
    (<any>$('.inputDate')).datepicker({ format: 'yyyy-mm-dd' });
    $('.single-select').select2({
      placeholder: '--Chọn một giá trị--',
      width: '350px',
    });
    $('.multi-select').select2({
      placeholder: '--Chọn nhiều giá trị--',
      multiple: true,
      width: '350px',
    });
    $('.myselect').select2({
      placeholder: '--Chọn nhiều giá trị--',
      multiple: true,
      width: '350px',
    });
    if (this.ticket) {
      console.log(this.ticket);
      this.ticketService.find(this.ticket._id).subscribe(
        res => {
          if (res.status == 200 && res.error == false) {
            if (res.data) {
              this.model = _.assign({}, res.data);
            } else {
              this.model = _.assign({}, this.ticket);
            }
          } else {
            this.model = _.assign({}, this.ticket);
          }
        },
        () => {
          this.model = _.assign({}, this.ticket);
        },
        () => {
          this.displaySubject = showPhoneNumberInString(this.model.subject, this.user);
          if (this.model.created_at) {
            this.minDate = new Date(this.model.created_at);
            this.model.created_at = moment(this.model.created_at).format('YYYY-MM-DD HH:mm');
          }
          if (this.model.updated_at) {
            this.model.updated_at = moment(this.model.updated_at).format('YYYY-MM-DD HH:mm');
          }
          if (this.model.duedate) {
            this.model.duedate = moment(this.model.duedate).format('YYYY-MM-DD HH:mm');
          }

          if (this.model.thoidiem) {
            this.model.thoidiem = moment(this.model.thoidiem).format('YYYY-MM-DD HH:mm');
          }

          this.model._id = this.ticket._id;
          if (!this.model.requester_id && this.model.request) {
            this.model.requester_id = this.model.request._id;
          }
          if (!this.model.request && this.model.requester_id) {
            this.userService
              .find({ _id: this.model.requester_id })
              .toPromise()
              .then(resUser => {
                if (resUser.status == 200 && resUser.error == false) {
                  this.model.request = _.assign({}, resUser.data);
                }
              });
          }
          if (this.model.assign_group_id) {
            this.agentInGroup = _.filter(this.agentInGroup, e => {
              if (parseInt(e.group_id) == parseInt(this.model.assign_group_id)) {
                return e;
              }
            });

            if (this.user.role == 'administrator') {
              this.agentInGroup.push({
                id: 'add',
                text: 'Chuyên viên',
                group_id: null,
              });
            }
          }

          this.model.cc_users = this.model.cc_users ? this.model.cc_users : [];
          this.model.follow_users = this.model.follow_users ? this.model.follow_users : [];
          this.model.exist_cc_me = this.model.cc_users.indexOf(this.user._id) != -1 ? true : false;
          this.model.exist_follow_me = this.model.follow_users.indexOf(this.user._id) != -1 ? true : false;

          console.log('model ne', this.model);
          if (this.model.tags) {
            if (typeof this.model.tags == 'string') {
              let arr_tags = this.model.tags.split(',');
              arr_tags = _.map(arr_tags, e => {
                return {
                  displayValue: e,
                };
              });
              this.model.tags = arr_tags;
            } else {
              this.model.tags = this.model.tags.map(e => ({
                displayValue: e,
              }));
            }
          } else {
            this.model.tags = [];
          }
          this.renderServices();
          this.getComment(this.model._id);
          if (
            this.model.assign_agent_id &&
            (!this.model.assign_group_id || this.model.assign_group_id == null || this.model.assign_group_id == ' ')
          ) {
            const agent = this.allAgent.find(e => e.id == this.model.assign_agent_id);
            this.model.assign_group_id = agent ? agent.group_id : '';
            this.is_load_data = false;
            this.changedAssignGroup({ value: this.model.assign_group_id });
          }
          setTimeout(() => {
            this.is_load_data = false;
          }, 800);
        }
      );
      this.submit_status = this.ticket.status ? this.ticket.status : 1;
      this.current_status = this.ticket.status ? this.ticket.status : 1;
      this.allStatus.forEach(status => {
        if (status.id == this.submit_status) {
          this.submit_status_label = status.text;
        }
      });
    }
  }

  renderServices() {
    for (let i = 0; i < this.allService.length - 1; i++) {
      const service = this.allService[i];
      if (this.model[service.field]) {
        this.model[service.field] = this.model[service.field].toString();
        const serviceChild = this.allService[i + 1];
        for (let j = 0; j < serviceChild.list.length; j++) {
          if (this.model[service.field] == serviceChild.list[j].parent_id) {
            serviceChild.displayList.push(serviceChild.list[j]);
          }
        }
        if (serviceChild.displayList.length > 1) {
          serviceChild.show = true;
          serviceChild.displayList.unshift({ id: '', text: '' });
        }
      }
    }
  }

  openMergeTicket() {
    this.modelMerge = {
      filter_code: '',
      searched: false,
    };
    this.listMergeTicket = [];
    this.currentPageMergeTicket = 1;
    this.totalItemMergeTicket = 0;
    this.totalPageMergeTicket = 0;

    this.modelContent.title = 'Hợp nhất ticket';
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.openModal(this.templateMergeTicket, config);
  }

  getListTickets(request: any = {}, sort: any = {}) {
    this.listMergeTicket = [];
    request.offset = this.page_size1 * (this.currentPageMergeTicket <= 0 ? 0 : this.currentPageMergeTicket - 1);
    request.limit = this.page_size1;

    this.ticketService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.listMergeTicket = res.data.tickets;
        this.listMergeTicket.forEach(e => {
          e.isMerged = false;
        });
        this.totalItemMergeTicket = res.data.total;
        const pageString = (this.totalItemMergeTicket / this.page_size1).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPageMergeTicket = totalpage;
      } else {
        this.listMergeTicket = [];
      }
    });
  }

  setPageMergeTicket(page: number) {
    if (page <= this.totalPageMergeTicket) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPageMergeTicket) {
        this.currentPageMergeTicket = page;
        this.getListTickets({ filters: JSON.stringify(this.optionMerge) });
      }
    } else {
      page = this.totalPageMergeTicket;
      $('#inputPage2').val(page);
      this.throwWarning('Số trang tối đa hiện tại là ' + page);
      if (page <= this.totalPageMergeTicket) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPageMergeTicket) {
          this.currentPageMergeTicket = page;
          this.getListTickets({ filters: JSON.stringify(this.optionMerge) });
        }
      }
    }
  }

  goPageMergeTicket(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPageMergeTicket(toPage);
    }
  }

  _keyPressPageMergeTicket(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  useTemplate($event) {
    const value = $event.value;
    const template = this.templates.find(template => template._id == value);
    if (template) {
      this.fields.forEach(value => {
        if (template[value.key]) {
          this.model[value.key] = template[value.key];
        } else {
          if (value.type == 'select') {
            this.model[value.key] = '-1';
          }
        }
      });

      if (template.subject) {
        this.model.subject = template.subject;
        this.displaySubject = showPhoneNumberInString(template.subject, this.user);
      }
      if (template.intro) {
        this.modelComment.content = template.intro;
      }
      if (template.assign && template.assign != -1) {
        if (template.assign == '[current-agent]') {
          this.model.assign_group_id = this.user.group_id;
          this.model.assign_agent_id = this.user._id;
        } else {
          this.userService.find({ _id: template.assign }).subscribe(res => {
            if (res.status == 200 && res.error == false) {
              this.model.assign_group_id = res.data.group_id;
              this.model.assign_agent_id = template.assign;
            }
          });
        }
      }
      if (template.cc && template.cc != -1) {
        if (template.cc == '[current-agent]') {
          if (this.model['cc_users'] && this.model['cc_users'].length > 0) {
            this.model.cc_users = _.concat(this.model.cc_users, [this.user._id]);
          } else {
            this.model.cc_users = [this.user._id];
          }
        } else {
          if (this.model['cc_users'] && this.model['cc_users'].length > 0) {
            this.model.cc_users = _.concat(this.model.cc_users, [template.cc]);
          } else {
            this.model.cc_users = [template.cc];
          }
        }
        this.model.cc_users = this.model.cc_users[0];
      } else {
        this.model.cc_users = [];
      }

      if (template.follow && template.follow != -1) {
        if (template.follow == '[current-agent]') {
          if (this.model['follow_users'] && this.model['follow_users'].length > 0) {
            this.model.follow_users = _.concat(this.model.follow_users, [this.user._id]);
          } else {
            this.model.follow_users = [this.user._id];
          }
        } else {
          if (this.model['follow_users'] && this.model['follow_users'].length > 0) {
            this.model.follow_users = _.concat(this.model.follow_users, [template.follow]);
          } else {
            this.model.follow_users = [template.follow];
          }
        }
        this.model.follow_users = this.model.follow_users[0];
      } else {
        this.model.follow_users = [];
      }
      if (template.priority && template.priority != -1) {
        this.model.priority_id = template.priority;
      }

      if (template.status && template.status != -1 && this.current_status != 5) {
        this.submit_status = parseInt(template.status);
        this.allStatus.forEach(status => {
          if (status.id == this.submit_status) {
            this.submit_status_label = status.text;
          }
        });
      }
    }
  }

  htmlEncode(value) {
    return $('<div/>').text(value).html();
  }

  getComment(ticket_id) {
    this.comments = [];
    this.commentService
      .list({ where: JSON.stringify({ ticket_id: ticket_id }) })
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.comments = res.data.comments;
          this.comments.forEach(comment => {
            comment.content = this.domSanitizer.sanitize(SecurityContext.HTML, comment.content);
            if (comment.created_at) {
              comment.created_at = moment(comment.created_at).format('YYYY-MM-DD HH:mm');
            }
            // kiem tra file ghi am

            if (comment.sems && comment.call_status == 'answer') {
              this.cdns.forEach(cdn => {
                const index = comment.sems.indexOf(cdn.ip);
                if (index == -1) {
                  if (!comment.callinfo) return;
                  const callInfo = JSON.parse(comment.callinfo);
                  const dateString = callInfo.startTime;
                  const [datePart, timePart] = dateString.split(' ');
                  const formattedDate = datePart.replace(/-/g, '/');
                  const [hour, minute] = timePart.split(':');
                  const temp = `${formattedDate}/${hour}/${minute}`;
                  comment.sems =
                    cdn.url + '/uploads/' + this.model.tenant_id + '/' + temp + '/' + comment.call_id + '.wav';
                }
              });
            }
          });
        } else {
          this.comments = [];
        }
      });
  }

  getMyFields() {
    const handleCheckPermission = (Pms: any) => {
      Pms.organization_id = Pms.organization_id || -2;
      Pms.group_id = Pms.group_id || -2;

      let PmsType = '0';
      if (Pms.status) {
        if (Pms.group_id == this.user.group_id || Pms.organization_id == this.user.organization_id) {
          PmsType = Pms.permission;
        }

        if (Pms.group_id == this.user.group_id && Pms.organization_id == this.user.organization_id) {
          PmsType = Pms.permission;
        }

        if (Pms.agents && Pms.agents.includes(this.user._id)) {
          PmsType = Pms.permission;
        }
      } else {
        PmsType = '3';
      }
      return PmsType;
    };

    return this.fieldService.allField({ target: 'ticket' }).map(res => {
      if (res.status == 200 && res.error == false) {
        this.fields = res.data;
        this.fields.forEach(element => {
          element.PmsType = handleCheckPermission(element.permission_detail || {});
          if (element.type == 'select') {
            element.data.unshift('--Chọn--');
          }
        });
      }
    });
  }

  getUserFields() {
    return this.fieldService.allField({ target: 'user' }).map(res => {
      if (res.status == 200 && res.error == false) {
        this.userFields = res.data;
      }
    });
  }

  loadEmailAccount() {
    return this.emailService.listAccount({}).map(res => {
      if (res.status == 200 && res.error == false) {
        res.data.list.forEach(d => {
          this.emailAccounts.push({
            id: d.EMAIL_ADDRESS,
            text: d.EMAIL_ADDRESS,
          });
        });
      }
    });
  }

  getStatus(data) {
    const statusList = [];
    data.forEach((c: any) => {
      statusList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allStatus = statusList;
  }

  offAutocomplete() {
    setTimeout(
      function () {
        this.showAutoComplete = false;
      }.bind(this),
      1000
    );
  }

  searchUser($event) {
    this.userList = [];
    this.model.requester_id = null;
    const keyword = $('#inputUser-' + this.tabIndex).val();

    if (keyword.length > 0) {
      this.is_searching = true;
      this.searchService.user({ keyword: keyword }).subscribe(
        res => {
          if (res.status == 200 && res.error == false) {
            this.userList = res.data;
          } else {
            this.userList = [];
          }
          this.is_searching = false;
        },
        error => {
          this.showAutoComplete = false;
        }
      );
    }
  }

  getPriorities(data) {
    const priorityList = [
      '--Chọn--',
      {
        id: '',
        text: '',
      },
    ];
    data.forEach((c: any) => {
      priorityList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allPriority = priorityList;
  }

  getTypes(data) {
    const typeList = [
      '--Chọn--',
      {
        id: '',
        text: '',
      },
    ];
    data.forEach((c: any) => {
      typeList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allType = typeList;
  }

  getServices(data) {
    const serviceList = [
      {
        field: 'service_id',
        show: true,
        list: [{ id: '', text: '', parent_id: '' }],
        displayList: [{ id: '-1', text: '--Chọn--', parent_id: '' }],
        order: 0,
      },
    ];
    data.forEach((c: any) => {
      if (c.parent_id) {
        let order = -1;
        for (let i = 0; i < serviceList.length; i++) {
          if (order != -1) {
            break;
          }
          for (let j = 0; j < serviceList[i].list.length; j++) {
            const service = serviceList[i].list[j];
            if (service.id == c.parent_id) {
              order = i + 1;
              break;
            }
          }
        }
        if (!serviceList[order]) {
          serviceList[order] = {
            field: 'service_id' + order,
            show: false,
            order: order,
            list: [
              {
                text: c.name,
                id: c.id.toString(),
                parent_id: c.parent_id.toString(),
              },
            ],
            displayList: [],
          };
        } else {
          serviceList[order].list.push({
            text: c.name,
            id: c.id.toString(),
            parent_id: c.parent_id.toString(),
          });
        }
      } else {
        serviceList[0].list.push({
          text: c.name,
          id: c.id.toString(),
          parent_id: '',
        });
        if (this.ticket.source_detail) {
          if (!c.source || c.source.indexOf(this.ticket.source_detail) > -1) {
            serviceList[0].displayList.push({
              text: c.name,
              id: c.id.toString(),
              parent_id: '',
            });
          }
        } else {
          if (!c.source || c.source.indexOf('hand') > -1) {
            serviceList[0].displayList.push({
              text: c.name,
              id: c.id.toString(),
              parent_id: '',
            });
          }
        }
      }
    });
    for (let i = 1; i < serviceList.length; i++) {
      serviceList[i].displayList.unshift({
        text: '--Chọn--',
        id: '-1',
        parent_id: '',
      });
    }
    this.allService = serviceList;
  }

  getGroup() {
    return this.groupService.allGroup({ target: 'user' }).map(res => {
      const groupList = [];
      const groupList_tmp = [];
      const groupUser = [];
      groupList.push({
        id: '',
        text: '-- Tất cả --',
      });
      groupList_tmp.push({
        id: '',
        text: '-- Tất cả --',
      });
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id.toString(),
        });
        groupList_tmp.push({
          text: c.name,
          id: c.id.toString(),
        });
        groupUser.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allUserGroup = groupUser;
      this.allFillterGroup = groupList_tmp;
      if (this.user.role == 'administrator') {
        groupList.push({
          id: 'add',
          text: 'Thêm mới',
        });
      }
      this.allGroup = groupList;
    });
  }

  changedUserGroup($event) {
    this.modelAgent.group_id = $event.value;
  }

  getAgentInGroup(assign_group_id) {
    if (assign_group_id) {
      this.userService
        .all({ group_id: assign_group_id })
        .toPromise()
        .then(res => {
          const agentList = [
            '--Chọn--',
            {
              id: '',
              text: '',
            },
          ];
          res.data.list.forEach((c: any) => {
            agentList.push({
              text: c.name,
              id: c._id,
            });
          });
          if (this.user.role == 'administrator') {
            agentList.push({
              id: 'add',
              text: 'Chuyên viên',
            });
          }
          this.agentInGroup = agentList;
        });
    }
  }

  getAllAgent() {
    return this.userService.all({}).map(res => {
      this.lstAgents = res.data.list;
      const agentList = [
        {
          id: '',
          text: '',
          email: '',
          group_id: null,
        },
      ];
      res.data.list.forEach((c: any) => {
        agentList.push({
          text: c.name,
          id: c._id,
          email: c.email,
          group_id: c.group_id,
        });
      });

      this.allAgent = agentList;
      this.agentInGroup = agentList;
    });
  }

  filterAgent() {
    this.currentPage = 1;
    const options = [];
    if (this.modelFilter.filter_agent_phone) {
      options.push({
        key: 'phone',
        condition: '=',
        value: this.modelFilter.filter_agent_phone,
      });
    }
    if (this.modelFilter.group_id) {
      options.push({
        key: 'group_id',
        condition: '=',
        value: this.modelFilter.group_id,
      });
    }
    this.getStaffs({ filters: JSON.stringify(options) });
  }

  getStaffs(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.userService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.list;
        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      } else {
        this.list = [];
      }
    });
  }

  filterConnector(event: any = null) {
    this.getConnectors(this.modelFillterConnector);
  }

  getConnectors(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    request['TYPE'] = this.connector_type == 'ivr' ? 3 : 1;
    this.IvrgatewayService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.ivrgateways;
        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      } else {
        this.list = [];
      }
    });
  }

  openFile() {
    (<any>$('#file-' + this.tabIndex)).trigger('click');
  }

  attachFile($event) {
    const files = $event.srcElement.files;
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        this.modelComment.attachments.push(this.commonService.file(res.data));
        $event.target.value = null;
      } else {
        this.throwError(res.data.message);
      }
    });
  }

  submit() {
    const status = this.submit_status;
    this.message = null;
    this.fields.forEach(f => {
      if (f.type == 'date' || f.type == 'select') {
        if (<any>$('#field-' + f.key + '-' + this.tabIndex).val() && <any>$('#field-' + f.key + '-' + this.tabIndex)
            .val()
            .trim() != '') {
          this.model[f.key] = <any>$('#field-' + f.key + '-' + this.tabIndex)
            .val()
            .trim();
        }
      } else if (f.type == 'multi-select' && <any>$('#field-' + f.key + '-' + this.tabIndex).val()) {
        this.model[f.key] = <any>$('#field-' + f.key + '-' + this.tabIndex).val();
      }
    });

    if (!this.model.requester_id) {
      this.throwError('Người yêu cầu không được bỏ trống!');
    } else if (!this.model.subject || this.model.subject.trim() == '') {
      this.throwError('Tiêu đề không được bỏ trống!');
    } else if (
      !this.modelComment.content ||
      (this.modelComment.content &&
        this.modelComment.content
          .replaceAll('<p>', '')
          .replaceAll('</p>', '')
          .replaceAll('<br>', '')
          .replaceAll('</br>', '')
          .replaceAll('&nbsp;', '')
          .trim() == '')
    ) {
      this.throwError('Nội dung không được bỏ trống!');
    } else {
      let check = true;
      this.fields.forEach(e => {
        if (e.is_required) {
          if (e.type == 'number') {
            if (!this.model[e.key] && this.model[e.key] != '0') {
              check = false;
              this.throwError('Thuộc tính ' + e.title + ' không được bỏ trống!');
            }
          } else if (e.type == 'text' || e.type == 'textarea' || e.type == 'date') {
            if (!this.model[e.key] || (this.model[e.key] && this.model[e.key].trim() == '')) {
              check = false;
              this.throwError('Thuộc tính ' + e.title + ' không được bỏ trống!');
            }
          } else if (e.type == 'select') {
            if (!this.model[e.key] || this.model[e.key] == '--Chọn--') {
              check = false;
              this.throwError('Thuộc tính ' + e.title + ' không được bỏ trống!');
            }
          } else if (e.type == 'multi-select') {
            if (!this.model[e.key]) {
              check = false;
              this.throwError('Thuộc tính ' + e.title + ' không được bỏ trống!');
            }
          }
        }
      });
      if (check) {
        const payload = _.assign({}, this.model);
        if (payload.tags && payload.tags.length > 0) {
          const _tags_arr = [];
          payload.tags.forEach(t => {
            _tags_arr.push(t.displayValue);
          });
          payload.tags = _tags_arr.length > 0 ? _tags_arr.join(',') : null;
        }
        delete payload.request;
        delete payload.exist_cc_me;
        delete payload.exist_follow_me;
        delete payload._id;
        delete payload.receiver;
        delete payload.assign_agent;
        payload['status'] = status;
        this.model.status = status;
        if (payload.duedate) {
          payload.duedate = moment(payload.duedate).format('YYYY-MM-DD HH:mm');
        }
        if (this.ticket && this.ticket._id) {
          this.ticketService.update(this.ticket._id, payload).subscribe(
            res => {
              if (res.status == 200 && !res.error) {
                this.throwSuccess('Cập nhật thành công!');
                if (this.modelComment.content && this.modelComment.content.trim() != '') {
                  this.modelComment['ticket_id'] = this.ticket._id;
                  this.commentService.create(this.modelComment).subscribe(rs => {
                    let attachment = '';
                    this.modelComment.attachments.forEach(file => {
                      attachment += file + ',';
                    });
                    let cc = '';
                    this.model.cc_users.forEach(user => {
                      if (user.email) {
                        cc += user.email + ',';
                      }
                    });
                    let bcc = '';
                    this.model.follow_users.forEach(user => {
                      if (user.email) {
                        bcc += user.email + ',';
                      }
                    });

                    if (this.modelComment.is_publish) {
                      if (this.model.request && this.model.request.email) {
                        const email = {
                          attachFile: attachment,
                          content: this.modelComment.content,
                          emailFrom: this.ticket.email_source,
                          emailMsgId: this.ticket.email_message_id,
                          emailTo: this.model.request.email,
                          subject: this.ticket.subject,
                          tenantId: this.user.tenant_id,
                          ticketId: this.ticket._id,
                          username: this.user.username,
                          agentId: localStorage.getItem('agentId'),
                        };
                        this.sendMail(email);
                      } else if (this.ticket['comment_id']) {
                        const comment = {
                          attachFile: attachment,
                          content: this.modelComment.content,
                          pageId: this.ticket.page_id,
                          pagePostId: this.ticket.page_post_id,
                          commentId: this.ticket.comment_id,
                          tenantId: this.user.tenant_id,
                          ticketId: this.ticket._id,
                        };
                        this.mailboxService
                          .postFullUrl(environment.url_ottgateway + '/facebook/comment', comment)
                          .subscribe(res => {
                            console.log(
                              'sent comment to ' +
                                this.ticket.comment_id +
                                ' page_id ' +
                                this.ticket.page_id +
                                ' status ' +
                                res.status
                            );
                          });
                      }
                    }
                    this.modelComment = {
                      is_publish: false,
                      attachments: [],
                    };
                    if (['chat', 'facebook', 'email', 'zalo'].indexOf(this.ticket.source_detail) > -1) {
                      if (status == 5 || status == 3 || this.ticket.assign_agent_id != this.model['assign_agent_id']) {
                        this.ticketService
                          .count({
                            source: this.ticket.source_detail,
                            assign_id: this.ticket.assign_agent_id,
                          })
                          .toPromise()
                          .then(res => {
                            if (res.status == 200 && res.error == false) {
                              this.socketService.execUpdateAssignMe({
                                assignAgentId: this.ticket.assign_agent_id,
                                total: res.data.assign_me,
                                source: this.ticket.source_detail,
                              });
                            }
                          });
                      }
                    }
                  });
                }
                const dataShare = res.data;
                dataShare.subject = this.model.subject;
                dataShare.assign_agent_id = this.model.assign_agent_id;
                dataShare.status = this.model.status;
                dataShare.updated_at = new Date();
                this.sharedService.onTicketUpdate.emit(dataShare);
                this.socketService.reloadLastestTicket();
                this.redirect(this.model, this.close_tab);
              } else {
                this.throwError('Cập nhật không thành công!');
              }
            },
            error => {
              this.throwError(error.message);
            }
          );
        } else {
          if (!this.model['assign_agent_id']) {
            if (this.user.group_id) {
              this.changedAssignGroup({ value: this.user.group_id });
              this.changedAssignUser({ value: this.user._id });
              payload.assign_group_id = this.user.group_id;
              payload.assign_agent_id = this.user._id;
            }
          }
          this.ticketService.create(payload).subscribe(
            res => {
              if (res.status == 200 && !res.error) {
                this.throwSuccess('Cập nhật thành công!');
                if (this.modelComment.content && this.modelComment.content.trim() != '') {
                  this.modelComment['ticket_id'] = res.data._id;
                  let attachment = '';
                  this.modelComment.attachments.forEach(file => {
                    attachment += file + ',';
                  });
                  let cc = '';
                  if (this.model.cc_users) {
                    this.model.cc_users.forEach(user => {
                      if (user.email) {
                        cc += user.email + ',';
                      }
                    });
                  }

                  let bcc = '';
                  if (this.model.follow_users) {
                    this.model.follow_users.forEach(user => {
                      if (user.email) {
                        bcc += user.email + ',';
                      }
                    });
                  }

                  if (this.model['assign_agent_id']) {
                    this.allAgent.forEach(agent => {
                      if (agent.id == this.model['assign_agent_id']) {
                        const email = {
                          attachFile: attachment,
                          bcc: bcc,
                          cc: cc,
                          content: this.modelComment.content,
                          emailFrom: res.data.email_source,
                          emailMsgId: '',
                          emailTo: agent.email,
                          subject: res.data.subject,
                          tenantId: this.user.tenant_id,
                          ticketId: res.data._id,
                          username: this.user.email,
                          agentId: localStorage.getItem('agentId'),
                        };
                        this.mailboxService.postFullUrl(environment.url_email + '/sentemail', email).subscribe(res => {
                          if (res.status == 'OK') {
                            console.log('sent mail to ' + agent.email);
                          }
                        });
                      }
                    });
                  }
                  this.commentService.create(this.modelComment).subscribe(rs => {
                    this.modelComment = {
                      is_publish: false,
                      attachments: [],
                    };
                  });
                }
                this.socketService.reloadLastestTicket();
                this.model._id = res.data._id;
                this.model.code = res.data.code;
                this.redirect(this.model, this.close_tab);
              } else {
                this.throwError(res.message);
              }
            },
            error => {
              this.throwError(error.message);
            }
          );
        }
      }
    }
  }

  execCall(phone) {
    if (UtilityService.isValidPhoneNumber(phone)) {
      this.socketService.execCall(phone, this.model._id, this.model.campaign_id);
    } else {
      this.throwError('Số điện thoại không hợp lệ!');
    }
  }

  execCallZcc(phone) {
    this.socketService.execCallZcc(phone, this.model._id, this.model.campaign_id);
  }

  volume(value) {
    if (value == 'on') {
      if (this.ticket.source_detail == 'CALL_INBOUND') {
        this.socketService.execMute(
          {
            callId: this.ticket.call_id,
          },
          value
        );
      } else {
        this.socketService.execCallOutRequestAction({
          callId: this.ticket.call_id,
          action: 'CALL_OUT_UNMUTE',
        });
      }
    } else {
      // this.is_mute = true;
      if (this.ticket.source_detail == 'CALL_INBOUND') {
        this.socketService.execMute(
          {
            callId: this.ticket.call_id,
          },
          value
        );
      } else {
        this.socketService.execCallOutRequestAction({
          callId: this.ticket.call_id,
          action: 'CALL_OUT_MUTE',
        });
      }
    }
  }

  hold(value) {
    if (value == 'on') {
      // this.is_hold = false;
      if (this.ticket.source_detail == 'CALL_INBOUND') {
        this.socketService.execHold(
          {
            callId: this.ticket.call_id,
          },
          value
        );
      } else {
        this.socketService.execCallOutRequestAction({
          callId: this.ticket.call_id,
          action: 'CALL_OUT_UNHOLD',
        });
      }
    } else {
      // this.is_hold = true;
      if (this.ticket.source_detail == 'CALL_INBOUND') {
        this.socketService.execHold(
          {
            callId: this.ticket.call_id,
          },
          value
        );
      } else {
        this.socketService.execCallOutRequestAction({
          callId: this.ticket.call_id,
          action: 'CALL_OUT_HOLD',
        });
      }
    }
  }

  execEndCall() {
    if (this.ticket.source_detail == 'CALL_INBOUND') {
      this.socketService.execEndCall({ callId: this.ticket.call_id });
    } else {
      this.socketService.execCallOutRequestAction({
        callId: this.ticket.call_id,
        action: 'TERMINATE',
      });
    }
  }

  toOutPhone() {
    this.is_out_phone = true;
    this.socketService.execToOutPhone({
      callId: this.ticket.call_id,
      phonenumber: this.modelPhoneOut.phone_out,
      divertType: 0,
    });
  }

  toACD(url) {
    this.is_to_ACD = true;
    this.socketService.execToACD({
      callId: this.ticket.call_id,
      sipId: url,
    });
  }

  toIVR(url) {
    this.is_to_IVR = true;
    this.socketService.execToIVR({
      callId: this.ticket.call_id,
      ivrId: url,
      campaignId: 0,
    });
  }

  invite(agent_id) {
    this.is_invite = true;
    this.socketService.execInvite({
      callId: this.ticket.call_id,
      fromAgentId: this.user.agent_id,
      toAgentId: agent_id,
      type: 1,
    });
  }

  forward(agent_id) {
    this.is_forward = true;
    this.socketService.execForward({
      callId: this.ticket.call_id,
      fromAgentId: this.user.agent_id,
      // dropAgentId: this.user.agent_id,
      toAgentId: agent_id,
    });
  }

  redirect(ticket, close) {
    if (close) {
      $('#tab-' + this.tabIndex).trigger('click');
      $('.main-content').css('display', 'block');
    } else {
      this.getComment(ticket._id);
      this.change_requester = false;
      this.comeback.emit({
        ticket: ticket,
      });
    }
  }

  getTemplate() {
    return this.templateService.getTicketTemplate(this.user._id).map(res => {
      this.templates = res.data;
      const templateList = [
        {
          id: '',
          text: '-- Sử dụng mẫu trả lời nhanh --',
        },
      ];
      res.data.forEach((c: any) => {
        templateList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.allTemplate = templateList;
    });
  }

  public selectUser(user) {
    this.showAutoComplete = false;
    this.model['requester_id'] = user._id;
    this.model['request'] = user;
    const input_value = user.name
      ? showPhoneNumberInString(user.name, this.user)
      : user.phone
        ? showPhoneNumberInString(user.phone, this.user)
        : user.email;
    $('#inputUser-' + this.tabIndex).val(input_value);
  }

  public addCCMe() {
    this.model['exist_cc_me'] = true;
    if (this.model['cc_users'] && this.model['cc_users'].length > 0) {
      this.model.cc_users = _.concat(this.model.cc_users, [this.user._id]);
    } else {
      this.model.cc_users = [this.user._id];
    }
  }

  public addFollowMe() {
    this.model['exist_follow_me'] = true;
    if (this.model.follow_users && this.model.follow_users.length > 0) {
      this.model.follow_users = _.concat(this.model.follow_users, [this.user._id]);
    } else {
      this.model.follow_users = [this.user._id];
    }
  }

  public changedCCUser(e: any): void {
    if (!this.is_load_data) {
      if (!e.value) {
        this.model['exist_cc_me'] = false;
      } else {
        this.model['exist_cc_me'] = e.value.indexOf(this.user._id) != -1;
      }
      if (!e.value) {
        this.model['cc_users'] = [];
      } else {
        this.model['cc_users'] = e.value;
      }
    }
  }

  public changedFollowUser(e: any): void {
    if (!this.is_load_data) {
      if (!e.value) {
        this.model['exist_follow_me'] = false;
      } else if (e.value.indexOf(this.user._id) != -1) {
        this.model['exist_follow_me'] = true;
      } else {
        this.model['exist_follow_me'] = false;
      }
      if (!e.value) {
        this.model['follow_users'] = [];
      } else {
        this.model['follow_users'] = e.value;
      }
    }
  }

  public changedService(e: any, services: any): void {
    if (!this.is_load_data) {
      this.model[services.field] = e.value;
      for (let i = services.order + 1; i < this.allService.length; i++) {
        this.model[this.allService[i].field] = null;
        this.allService[i].show = false;
        this.allService[i].displayList = [];
      }
      if (services.order + 1 < this.allService.length) {
        for (let i = 0; i < this.allService[services.order + 1].list.length; i++) {
          const s = this.allService[services.order + 1].list[i];
          if (s.parent_id == e.value) {
            this.allService[services.order + 1].displayList.push(s);
          }
        }
        if (this.allService[services.order + 1].displayList.length > 0) {
          this.allService[services.order + 1].displayList.unshift({
            id: '',
            text: '',
          });
          this.allService[services.order + 1].show = true;
        }
        this.model[this.allService[services.order + 1].field] = this.model[this.allService[services.order + 1].field];
      }
      for (let i = 1; i < this.allService.length; i++) {
        this.allService[i].displayList.unshift({
          text: '--Chọn--',
          id: '-1',
          parent_id: '',
        });
      }
    }
  }

  public changedType(e: any): void {
    if (!this.is_load_data) {
      this.model['type_id'] = e.value;
    }
  }

  public changedPriority(e: any): void {
    if (!this.is_load_data) {
      this.model['priority_id'] = e.value;
    }
  }

  public changedStatus(status_id, text) {
    if (!this.is_load_data) {
      this.submit_status = status_id;
      this.submit_status_label = text;
    }
  }

  public changedValueMyField(e, key): void {
    let value = e.value;
    if (['-1', '--Chọn--', 'Chọn', ''].includes(value)) {
      value = null;
    }
    if (!this.is_load_data) {
      this.model[key] = value;
    }
  }

  public changedAssignGroup($event) {
    if (!this.is_load_data) {
      if ($event.value == 'add') {
        this.message = null;
        this.modelGroup = {};
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
        };
        this.modalRef = this.modalService.show(this.templateGroup, config);
      } else if ($event.value) {
        this.model['assign_group_id'] = $event.value;
        this.agentInGroup = [
          {
            id: '',
            text: '',
            group_id: null,
          },
        ];
        this.allAgent.forEach(e => {
          if (parseInt(e.group_id) == parseInt($event.value)) {
            this.agentInGroup.push(e);
          }
        });
      }
      this.can_assign_agent_id = typeof this.model['assign_group_id'] != 'object';
      if (this.model['assign_group_id'] == 'all') {
        this.can_assign_agent_id = false;
      }
      if (!this.model['assign_group_id']) {
        this.can_assign_agent_id = false;
      }
    }
  }

  public changedAssignUser($event) {
    if (!this.is_load_data) {
      if ($event.value == 'add') {
        this.message = null;
        this.modelAgent = {
          group_id: this.model.assign_group_id ? this.model.assign_group_id : null,
        };
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
        };
        this.modalRef = this.modalService.show(this.templateUser, config);
        this.for_what = 'assign_agent';
      } else if ($event.value) {
        this.model['assign_agent_id'] = $event.value;
      } else if (!$event.value) {
        this.model['assign_agent_id'] = '';
      }
    }
  }

  public changedFilterGroup(e: any): void {
    if (!this.is_load_data) {
      if (e.value) {
        this.modelFilter.group_id = e.value;
      }
    }
  }

  addGroup() {
    this.groupService.create(this.modelGroup).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.getGroup();
          this.modalRef.hide();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  addAgent() {
    if (this.for_what == 'assign_agent') {
      this.modelAgent['group_id'] = this.model.assign_group_id;
    }
    this.userService.create(this.modelAgent).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.is_load_data = true;
            this.toastr.success('Cập nhật thành công, vui lòng chờ trong giây lát để cập nhật thông tin', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            if (this.for_what == 'requester') {
              this.model.request = res.data;
              this.model.requester_id = res.data._id;
              setTimeout(() => {
                this.is_load_data = false;
              }, 1000);
            } else if (this.for_what == 'assign_agent') {
              // this.getAgentInGroup(this.model.assign_group_id);
              // this.model['assign_agent_id'] = res.data._id;
              setTimeout(() => {
                this.getAllAgent().subscribe();
                setTimeout(() => {
                  this.getAgentInGroup(this.model.assign_group_id);
                }, 500);
                setTimeout(() => {
                  this.model['assign_agent_id'] = res.data._id;
                  this.is_load_data = false;
                }, 1000);
              }, 4500);
            }

            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }

  openNewUser(for_what) {
    this.for_what = for_what;
    this.modelAgent = { group_id: null, role: 'end_user' };
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(this.templateUser, config);
  }

  // function for result template
  public templateResult: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
    if (state.id == 'add') {
      return jQuery('<span class="ml-10">' + state.text + '</span>');
    } else {
      return state.text;
    }
  };

  // function for selection template
  public templateSelection: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
    if (state.id == 'add') {
      return jQuery('<span class="ml-10">' + state.text + '</span>');
    } else {
      return state.text;
    }
  };

  initPage() {
    this.list = [];
    this.totalItem = 0;
    this.totalPage = 0;
    this.page_size = 5;
    this.currentPage = 1;
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.getStaffs();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.getStaffs();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  setPageConnector(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.getConnectors();
      }
    } else {
      page = this.totalPage;
      $('#inputPageConnector').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.getConnectors();
        }
      }
    }
  }

  goPage2Connector(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPressConnector(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  delAttactment(index) {
    this.modelComment.attachments.splice(index, 1);
  }

  sendMail(email) {
    this.mailboxService.postFullUrl(environment.url_email + '/sentemail', email).subscribe(res => {
      if (res.status == 200) {
        this.toastr.success('Gửi mail đến ' + this.model.request.email + ' thành công', '', {
          timeOut: 5000,
          positionClass: 'toast-bottom-right',
        });
        this.handleCloseMailModal();
      } else {
        this.toastr.error('Gửi mail đến ' + this.model.request.email + ' thất bại', '', {
          timeOut: 5000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  sendMailBox() {
    let error = false;
    if (!this.modelMail.FROM) {
      error = true;
    }
    if (!this.modelMail.TO) {
      error = true;
    }
    if (!this.modelMail.SUBJECT) {
      error = true;
    }
    if (!this.modelMail.CONTENT) {
      error = true;
    }
    if (!error) {
      const comment = {
        attachments: this.modelMail.ATTACH_FILE,
        content: this.modelMail.CONTENT,
        is_publish: true,
        ticket_id: this.ticket._id,
      };
      this.commentService.create(comment).subscribe(rs => {
        let attachment = '',
          CC = '',
          BCC = '',
          content_type = 1;
        if (this.modelMail.CC && this.modelMail.CC.length > 0) {
          const tmp_CC = _.map(this.modelMail.CC, e => {
            return e.displayValue;
          });
          CC = tmp_CC.join(',');
        }
        if (this.modelMail.BCC && this.modelMail.BCC.length > 0) {
          const tmp_BCC = _.map(this.modelMail.BCC, e => {
            return e.displayValue;
          });
          BCC = tmp_BCC.join(',');
        }
        if (this.modelMail.ATTACH_FILE && this.modelMail.ATTACH_FILE.length > 0) {
          attachment = this.model.ATTACH_FILE.join(',');
          content_type = 3;
        }
        const email = {
          attachFile: attachment,
          content: this.modelMail.CONTENT,
          emailFrom: this.modelMail.FROM,
          emailTo: this.modelMail.TO,
          cc: CC,
          bcc: BCC,
          emailMsgId: this.ticket.email_message_id,
          subject: this.modelMail.SUBJECT,
          tenantId: this.user.tenant_id,
          ticketId: this.ticket._id,
          username: this.user.username,
          agentId: localStorage.getItem('agentId'),
          contentType: content_type,
        };
        this.sendMail(email);
        this.redirect(this.ticket, false);
      });
    } else {
      this.toastr.error('Các trường bắt buộc điền không được để trống', '', {
        timeOut: 5000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  async openModalSpeechToText(id?: any) {
    await this.aiGatwayService.getContentAudio(id).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.audio_contents = res.data ? res.data.content : [];
          const config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            class: 'modal-lg',
          };
          this.openModal(this.templateAudioContent, config);
        } else {
          this.throwError();
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  openTemplateMail() {
    this.modelMail.FROM = this.ticket.email_source;
    this.modelMail.TO = this.ticket.request.email;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.modalRef = this.modalService.show(this.templateMail, config);
    this.hideSelect2();
  }

  attachFileMail($event) {
    const files = $event.srcElement.files;
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        if (this.modelMail['ATTACH_FILE']) {
          this.modelMail['ATTACH_FILE'].push(res.data);
        } else {
          this.modelMail['ATTACH_FILE'] = [res.data];
        }
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 5000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  deleteFile(file) {
    this.modelMail['ATTACH_FILE'] = _.pull(this.model['ATTACH_FILE'], file);
  }

  handleCloseMailModal() {
    this.modelMail = {};
    this.modalRef.hide();
  }

  hideSelect2() {
    const els = document.getElementsByClassName('modal-backdrop') as HTMLCollectionOf<HTMLElement>;
    const elements = document.getElementsByClassName('modal') as HTMLCollectionOf<HTMLElement>;
    Array.from(elements).forEach(r => {
      r.style.zIndex = String(9999999);
    });
    Array.from(els).forEach(r => {
      r.style.zIndex = String(9999990);
    });
  }

  loadZaloOa() {
    this.allOaZalo = [];
    this.socialService.listPageV2({ type: 0 }).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        res.data.list.forEach(item => {
          this.allOaZalo.push({
            id: item.page_id,
            text: item.page_name,
          });
        });
      } else {
        this.allOaZalo = [];
      }
    });
  }

  loadTemplate(source: any = 'email') {
    this.coreTemplateService.list(source, {}).subscribe(res => {
      if (res.status == 200 && !res.error) {
        switch (source) {
          case 'email':
            this.lstTemplateEmail = res.data.data;
            this.allTemplateEmail = res.data.data.map(item => {
              return { id: item.id, text: item.template_name };
            });
            break;
          case 'sms':
            this.lstTemplateSms = res.data.data;
            this.allTemplateSms = res.data.data.map(item => {
              return { id: item.id, text: item.template_name };
            });
            break;
          case 'zns':
            this.lstTemplateZns = res.data.data;
            this.allTemplateZns = res.data.data.map(item => {
              return { id: item.id, text: item.template_name };
            });
            break;
          default:
            break;
        }
      }
    });
  }

  async setUpTemplateModal() {
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Gửi ZNS',
      submit_title: 'Gửi',
    };
    this.modelDisplay = [
      {
        key: 'to',
        label: 'Gửi đến',
        type: FormFieldType.Select2,
        value: this.modelZns.to,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: { data: this.phoneArray },
      },
      {
        key: 'from',
        label: 'Zalo OA',
        type: FormFieldType.Select2,
        value: this.modelZns.from,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
        options: { data: this.allOaZalo },
      },
      {
        key: 'template_fake_id',
        label: 'Mẫu gửi tin',
        type: FormFieldType.Select2,
        value: this.modelZns.template_fake_id,
        required: true,
        disabled: false,
        width: 'full',
        order: 2,
        options: { data: this.allTemplateZns },
      },
      {
        key: 'content',
        label: 'Nội dung',
        type: FormFieldType.Textarea,
        value: this.modelZns.content,
        required: true,
        disabled: true,
        width: 'full',
        order: 3,
        options: { class: 'mh-150' },
      },
      {
        key: 'mapping_key',
        label: 'Gán giá trị cho biến',
        type: '',
        value: '',
        required: false,
        disabled: true,
        width: 'full',
        order: 4,
      },
      {
        key: 'note_content',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted">Lưu ý: Vui lòng điền đẩy đủ các thông tin cần thiết. Nội dung của biến sẽ tự động gán với các giá trị đã được thiết lập sẵn.</span>`,
        order: 4,
      },
    ];
    let order = this.modelDisplay.length;
    for (const item of this.contentKeyArray) {
      order++;
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'key:' + item.key,
          label: item.key,
          type: FormFieldType.Text,
          value: item.value,
          placeholder: item.placeholder,
          required: true,
          disabled: true,
          condition: [{ key: 'content', condition: '!=', value: '' }],
          width: 'full',
          order: order,
        },
      ];
    }
  }

  async openTemplateZns() {
    await this.loadTemplate('zns');
    this.message = null;
    this.phoneArray = [];
    this.contentKeyArray = [];
    this.allTemplateZns = [];
    let phoneArr = [this.ticket.request.phone];
    if (this.ticket.request.sub_phone && this.ticket.request.sub_phone.length > 0) {
      phoneArr = [...phoneArr, ...this.ticket.request.sub_phone];
    }
    phoneArr.forEach(r => {
      this.phoneArray.push({ id: r, text: this.showPhoneNumberInString(r, this.user) });
    });
    this.modelZns = {
      to: this.ticket.request.phone,
      from: '',
      template_id: '',
      template_data: {},
      content: '',
    };
    await this.setUpTemplateModal();
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(this.templateZNS, config);
  }

  changedPhone($event) {
    this.modelZns['to'] = $event.value;
  }

  async changedOaZalo(value) {
    this.modelZns['from'] = value;
    this.modelZns['content'] = '';
    this.modelZns['template_fake_id'] = '';
    this.contentKeyArray = [];
    this.allTemplateZns = [{ id: '', text: 'Chọn' }];
    this.lstTemplateZns.forEach(res => {
      if (res.oa_id == value) {
        this.allTemplateZns.push({
          id: res.id,
          text: res.template_name,
        });
      }
    });
  }

  async bindingKey(key_obj) {
    for (const key_object in key_obj) {
      const arr = key_obj[key_object].split(':');
      let value = '';
      let placeholder = '';
      if (arr.length > 0) {
        if (arr[0] == FieldType.User) {
          for (const f of UserField) {
            const ar = f.id.split(':');
            if (arr[1] == ar[1]) {
              placeholder = f.text;
            }
          }

          for (const f of this.userFields) {
            if (arr[1] == f.key) {
              placeholder = f.title;
            }
          }
          let preValue = this.ticket.request[arr[1]];
          if (preValue) {
            if (arr[1] == 'customer_type') {
              const obj = CustomerType.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            } else if (arr[1] == 'gender') {
              const obj = Gender.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            } else if (arr[1] == 'group_id') {
              const obj = this.allGroup.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            }
            value = preValue;
          } else {
            value = '';
          }
        } else if (arr[0] == FieldType.Ticket) {
          for (const f of TicketField) {
            const ar = f.id.split(':');
            if (arr[1] == ar[1]) {
              placeholder = f.text;
            }
          }

          for (const f of this.fields) {
            if (arr[1] == f.key) {
              placeholder = f.title;
            }
          }
          let preValue = this.ticket[arr[1]];
          if (preValue) {
            if (arr[1] == 'duedate') {
              preValue = preValue ? UtilityService.getFormattedDate(new Date(preValue)) : '';
            } else if (arr[1] == 'priority_id') {
              const obj = this.allPriority.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            } else if (arr[1] == 'type_id') {
              const obj = this.allType.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            }
            value = preValue;
          } else {
            value = '';
          }
        } else if (arr[0] == FieldType.Expert) {
          for (const f of ExpertField) {
            const ar = f.id.split(':');
            if (arr[1] == ar[1]) {
              placeholder = f.text;
            }
          }

          for (const f of this.userFields) {
            if (arr[1] == f.key) {
              placeholder = f.title;
            }
          }
          const agent = this.lstAgents.find(a => a._id == this.ticket.assign_agent_id);
          let preValue = '';
          if (agent) {
            preValue = agent[arr[1]];
            if (arr[1] == 'customer_type') {
              const obj = CustomerType.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            } else if (arr[1] == 'gender') {
              const obj = Gender.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            } else if (arr[1] == 'group_id') {
              const obj = this.allGroup.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            } else if (arr[1] == 'role') {
              const obj = RoleForAgent.find(r => r.id == preValue);
              preValue = obj ? obj.text : '';
            }
            value = preValue;
          } else {
            value = '';
          }
        }
      }
      this.contentKeyArray.push({
        key: key_object,
        value: value,
        placeholder: placeholder,
      });
    }
  }

  async changedZnsTemplate(value) {
    const template = this.lstTemplateZns.find(template => template.id == value);
    this.contentKeyArray = [];
    if (template) {
      this.modelZns['template_id'] = template.template_id;
      this.modelZns['content'] = template.template_content;
      const key_obj = JSON.parse(template.key_object);
      await this.bindingKey(key_obj);
    }
  }

  sendZns() {
    this.message = null;
    const template_data = {};
    let err_key_object = false;
    this.contentKeyArray.forEach(item => {
      if (!item.value) {
        err_key_object = true;
      }
      template_data[item.key] = item.value;
    });
    if (err_key_object) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Hãy điền đầy đủ các trường thông tin!',
      };
      return;
    }
    // TODO: reformat this later
    this.modelZns.template_id = this.modelZns.template_fake_id;
    this.modelZns['template_data'] = template_data;
    delete this.modelZns.content;
    delete this.modelZns.template_fake_id;
    delete this.modelZns.note_content;
    delete this.modelZns.mapping_key;
    for (const key in this.modelZns) {
      if (key.includes(':')) {
        delete this.modelZns[key];
      }
    }
    this.modelZns['ticket_id'] = this.ticket._id;
    this.socialService.sendZnsByTemplate(this.modelZns).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.toastr.error('Gửi ZNS thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Gửi ZNS thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  handleCloseZnsModal() {
    this.modelZns = {
      to: this.ticket.request.phone,
      from: '',
      template_id: '',
      template_data: {},
      content: '',
    };
    this.message = null;
    this.modalRef.hide();
  }

  handleCloseSmsModal() {
    this.modelSms = {
      to: this.ticket.request.phone,
      from: '',
      template_data: {},
      content: '',
    };
    this.contentKeyArray = [];
    this.message = null;
    this.modalRef.hide();
  }

  handleSubmitTemplate(item?: any) {
    this.modelZns = _.merge({}, this.modelZns, item);
    this.sendZns();
  }

  async onChangeValueModelTemplate(key: any, item: any) {
    this.modelZns = _.merge({}, this.modelZns, item);
    if (key == 'from') {
      await this.changedOaZalo(this.modelZns.from);
    }
    if (key == 'template_fake_id') {
      await this.changedZnsTemplate(this.modelZns.template_fake_id);
    }
    await this.setUpTemplateModal();
  }

  async setupSmsTemplate() {
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Gửi SMS',
      submit_title: 'Gửi',
    };
    this.modelDisplay = [
      {
        key: 'to',
        label: 'Gửi đến',
        type: FormFieldType.Select2,
        value: this.modelSms.to,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: { data: this.phoneArray },
      },
      {
        key: 'display_from',
        label: 'Mẫu gửi tin',
        type: FormFieldType.Select2,
        value: this.modelSms.display_from,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
        options: { data: this.allTemplateSms },
      },
      {
        key: 'content',
        label: 'Nội dung',
        type: FormFieldType.Textarea,
        value: this.modelSms.content,
        required: true,
        disabled: true,
        width: 'full',
        order: 2,
        options: { class: 'mh-150' },
      },
      {
        key: 'mapping_key',
        label: 'Gán giá trị cho biến',
        type: '',
        value: '',
        required: false,
        disabled: true,
        condition: this.contentKeyArray.length > 0,
        width: 'full',
        order: 3,
      },
      {
        key: 'note_content',
        label: '',
        condition: this.contentKeyArray.length > 0,
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted">Lưu ý: Vui lòng điền đẩy đủ các thông tin cần thiết. Nội dung của biến sẽ tự động gán với các giá trị đã được thiết lập sẵn.</span>`,
        order: 4,
      },
    ];
    let order = this.modelDisplay.length;
    if (this.contentKeyArray.length > 0) {
      for (const item of this.contentKeyArray) {
        order++;
        this.modelDisplay = [
          ...this.modelDisplay,
          {
            key: 'key:' + item.key,
            label: item.key,
            type: FormFieldType.Text,
            value: item.value,
            placeholder: item.placeholder,
            required: true,
            disabled: true,
            condition: [{ key: 'content', condition: '!=', value: '' }],
            width: 'full',
            order: order,
          },
        ];
      }
    }
  }

  async openTemplateZms() {
    await this.loadTemplate('sms');
    this.message = null;
    this.phoneArray = [];
    let phoneArr = [this.ticket.request.phone];
    if (this.ticket.request.sub_phone && this.ticket.request.sub_phone.length > 0) {
      phoneArr = [...phoneArr, ...this.ticket.request.sub_phone];
    }
    phoneArr.forEach(r => {
      this.phoneArray.push({ id: r, text: this.showPhoneNumberInString(r, this.user) });
    });
    this.modelSms = {
      to: this.ticket.request.phone,
      display_from: '',
      from: '',
      template_data: {},
      content: '',
    };
    await this.setupSmsTemplate();
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(this.templateSMS, config);
  }

  async onChangeValueModelSms(key: any, item: any) {
    this.modelSms = _.merge({}, this.modelSms, item);
    if (key == 'display_from') {
      await this.changedSmsTemplate(this.modelSms.display_from);
    }
    await this.setupSmsTemplate();
  }

  async handleSubmitSms(item?: any) {
    this.modelSms = _.merge({}, this.modelSms, item);
    this.sendSms();
  }

  async changedSmsTemplate(value) {
    const template = this.lstTemplateSms.find(template => template.id == value);
    this.contentKeyArray = [];
    if (template) {
      this.modelSms['content'] = template.template_content;
      this.modelSms['from'] = template.brand_name;
      const key_obj = JSON.parse(template.key_object);
      await this.bindingKey(key_obj);
    }
  }

  async sendSms() {
    this.message = null;
    const template_data = {};
    let err_key_object = false;
    this.contentKeyArray.forEach(item => {
      if (!item.value) {
        err_key_object = true;
      }
      template_data[item.key] = item.value;
    });
    if (!this.modelSms.to || (this.modelSms.to && this.modelSms.to.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Người nhận không được bỏ trống !',
      };
      return;
    }
    if (!this.modelSms.from || (this.modelSms.from && this.modelSms.from.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Mẫu gửi tin không được bỏ trống !',
      };
      return;
    }
    if (!this.modelSms.content || (this.modelSms.content && this.modelSms.content.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Nội dung gửi tin không được bỏ trống !',
      };
      return;
    }
    if (err_key_object && this.contentKeyArray.length > 0) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Hãy điền đầy đủ các trường thông tin!',
      };
      return;
    }
    this.modelSms['content'] = Mustache.render(this.modelSms.content, template_data);
    for (const key in this.modelSms) {
      if (key.includes(':')) {
        delete this.modelSms[key];
      }
    }
    this.modelSms['ticket_id'] = this.ticket._id;
    const payload = {
      ticket_id: this.modelSms.ticket_id,
      from: this.modelSms.from,
      to: this.modelSms.to,
      template_id: this.modelSms.display_from,
    };
    this.socialService.sendSms(payload).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.toastr.error('Gửi SMS thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Gửi SMS thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  changeEmailFrom($event) {
    this.modelMail.FROM = $event.value;
  }

  async handleMergeAction() {
    await this.getData();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/ticket/detail_ticket.component.ts